import { Injectable } from '@angular/core';
import { MixpanelService } from './mixpanel.service';
import { WebtrendsService } from './webtrends.service';
import { AnalyticService } from './analytic.service';

@Injectable({
  providedIn: 'root',
})
export class StoreAnalyticsService {

  constructor(private webtrendsService: WebtrendsService,
              private analyticService: AnalyticService,
              private mixpanelService: MixpanelService
  ) {
  }

  trackPageViewed(currentPage, previousPage): void {
    this.mixpanelService.track('Page Viewed', {
      'Page Name': currentPage,
      'Previous Page': previousPage
    });
  }

  trackAccountCreated(user, duration): void {
    this.mixpanelService.register({
      Role: user.role,
      Company: user.company,
      Email: user.emailAddress,
    });

    this.mixpanelService.track('Account Created', {
      Duration: duration
    });

    this.mixpanelService.people.set({
      Role: user.role,
      Company: user.company,
      Email: user.emailAddress,
    });

    this.analyticService.trackSignup();
    this.webtrendsService.track({type: 'NavigationEnd'});
  }

  trackTermsAgreement(dateSigned, duration): void {
    this.mixpanelService.people.set_once({'Sign Up Date': dateSigned});
    this.mixpanelService.track('Terms and Conditions Accepted', {'Duration': duration});
  }

  trackAccountCreatedFailed(error, duration): void {
    this.mixpanelService.track('Account Creation Failed', {
      'Creation Failure Reason': error,
      'Duration': duration
    });
  }
}
